import * as Yup from 'yup';

export const PEOPLE_FINDER_PROJECT_OPTIONS = [
  { label: 'Any', value: 'any' },
  { label: 'Has project', value: 'has_project' },
  { label: 'No project', value: 'no_project' },
];

export const usePeopleFinderProjectFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    hasPeopleFinderProject: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ hasPeopleFinderProject }) => {
    setFilters(
      { hasPeopleFinderProject: hasPeopleFinderProject.value || 'any' },
      {
        removeFilters: hasPeopleFinderProject.value === 'any' ? ['hasPeopleFinderProject'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
  };
};
